export const validatePassword = (value: string) =>
  value.length === 0 ? "Password is required" : undefined;
